import {UtilityService} from '../service/utility.service';

/**
 * @class
 * @description This class maintains the model structure for displaying and Administrator.
 * @export
 * @name AdministratorApiModel
 */
export class AdministratorApiModel {

  /**
   * @default new Date()
   * @description This property contains the timestamp at which the administrator was created.
   * @memberof AdministratorApiModel
   * @name AdministratorApiModel#created
   * @property
   * @public
   * @type {Date}
   */
  public created: Date = UtilityService.DateTimeUtc();

  /**
   * @description This property contains the email address of the administrator.
   * @memberof AdministratorApiModel
   * @name AdministratorApiModel#emailAddress
   * @property
   * @public
   * @type {string}
   */
  public emailAddress!: string;

  /**
   * @description This property contains the first name of the administrator.
   * @memberof AdministratorApiModel
   * @name AdministratorApiModel#firstName
   * @property
   * @public
   * @type {string}
   */
  public firstName!: string;

  /**
   * @description This property contains the last name of the administrator.
   * @memberof AdministratorApiModel
   * @name AdministratorApiModel#lastName
   * @property
   * @public
   * @type {string}
   */
  public lastName!: string;

  /**
   * @default false
   * @description This property denotes whether the administrator is locked or not.
   * @memberof AdministratorApiModel
   * @name AdministratorApiModel#locked
   * @property
   * @public
   * @type {boolean}
   */
  public locked: boolean = false;

  /**
   * @default false
   * @description This property denotes whether the administrator is online or not.
   * @memberof AdministratorApiModel
   * @name AdministratorApiModel#online
   * @property
   * @public
   * @type {boolean}
   */
  public online: boolean = false;

  /**
   * @description This property contains the password of the administrator.
   * @memberof AdministratorApiModel
   * @name AdministratorApiModel#peoId
   * @property
   * @public
   * @type {string?}
   */
  public password: string | undefined;

  /**
   * @description This property contains the password confirmation of the administrator.
   * @memberof AdministratorApiModel
   * @name AdministratorApiModel#passwordConfirmation
   * @property
   * @public
   * @type {string?}
   */
  public passwordConfirmation?: string;

  /**
   * @default true
   * @description This property denotes whether the password of the administrator expires or not.
   * @memberof AdministratorApiModel
   * @name AdministratorApiModel#passwordExpires
   * @property
   * @public
   * @type {boolean}
   */
  public passwordExpires: boolean = false;

  /**
   * @default new Date()
   * @description This property contains the timestamp at which the administrator's password was last changed.
   * @memberof AdministratorApiModel
   * @name AdministratorApiModel#passwordLastChanged
   * @property
   * @public
   * @type {Date?}
   */
  public passwordLastChanged: Date | null | undefined = null;

  /**
   * @default false
   * @description This property denotes whether the administrator should be prompted to change their password or not.
   * @memberof AdministratorApiModel
   * @name AdministratorApiModel#passwordPromptForChange
   * @property
   * @public
   * @type {boolean}
   */
  public passwordPromptForChange: boolean = false;

  /**
   * @default false
   * @description This property denotes whether the administrator has been selected in the UI or not.
   * @memberof AdministratorApiModel
   * @name AdministratorApiModel#selected
   * @property
   * @public
   * @type {boolean}
   */
  public selected: boolean = false;

  /**
   * @default new Date()
   * @description This property contains the timestamp at which the administrator was last updated.
   * @memberof AdministratorApiModel
   * @name AdministratorApiModel#updated
   * @property
   * @public
   * @type {Date}
   */
  public updated: Date = UtilityService.DateTimeUtc();
}
